import { useEffect } from "react";
import { Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
// services
import User from "../services/user";

const LoginPage = () => {
	const { t } = useTranslation();

	useEffect(() => {
		User.login();
	}, []);

	return (
		<div style={{display: "flex", height: window.innerHeight}}>
			<Paper style={{margin: "auto", padding: "16px", width: "300px"}}>
				{t("generic.redirecting")}
			</Paper>
		</div>
	);
};

export default LoginPage;
